import { createSlice } from '@reduxjs/toolkit';
import { BillOfMaterialsDetailStateType } from 'src/types/billOfMaterialsDetail';

const initialState: BillOfMaterialsDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const billOfMaterialsDetailSlice = createSlice({
    name: 'billOfMaterialsDetail',
    initialState,
    reducers: {
        getBillOfMaterialsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getBillOfMaterialsDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getBillOfMaterialsDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createBillOfMaterialsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createBillOfMaterialsDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createBillOfMaterialsDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateBillOfMaterialsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateBillOfMaterialsDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateBillOfMaterialsDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearBillOfMaterialsDetail: () => initialState,
    },
});

export const {
    getBillOfMaterialsDetailFetch,
    getBillOfMaterialsDetailFetchSuccess,
    getBillOfMaterialsDetailFetchFailure,
    createBillOfMaterialsDetailFetch,
    createBillOfMaterialsDetailFetchSuccess,
    createBillOfMaterialsDetailFetchFailure,
    updateBillOfMaterialsDetailFetch,
    updateBillOfMaterialsDetailFetchSuccess,
    updateBillOfMaterialsDetailFetchFailure,
    clearBillOfMaterialsDetail,
} = billOfMaterialsDetailSlice.actions;

export default billOfMaterialsDetailSlice.reducer;
